/**
 * Map, которая может возвращать значение по умолчанию, если оно заданно.
 */
class MapWithDefault<K, V> extends Map<K, V> {
    private _defaultValue: V;

    set defaultValue(defaultValue: V) {
        this._defaultValue = defaultValue;
    }

    get(key: K): V {
        return this.has(key) ? super.get(key) : this._defaultValue;
    }
}

/**
 * Builder для Map, которая умеет возвращать значение по умолчанию.
 */
export class MapBuilder<K, V> {
    private customMap: MapWithDefault<K, V> = new MapWithDefault<K, V>();

    /**
     * Создает новый MapBuilder.
     */
    public static create<K, V>() {
        return new MapBuilder<K, V>();
    }

    /**
     * Устанавливает значение по заданному ключу.
     *
     * @param key ключ
     * @param value значение
     */
    public value = (key: K, value: V): this => {
        this.customMap.set(key, value);
        return this;
    };

    /**
     * Устанавливает значение по умолчанию.
     *
     * @param value значение по умолчанию
     */
    public defaultValue = (value: V): this => {
        this.customMap.defaultValue = value;
        return this;
    };

    /**
     * Возвращает созданную
     */
    public build = (): Map<K, V> => {
        return this.customMap;
    };
}
